// `ModelError`: what the store throws (`invalid` and `notFound`), with the Swift's messages. Its own module, so the
// document-level writes (maps) can throw it without importing the store.

export class ModelError extends Error {
  constructor(readonly kind: 'invalid' | 'notFound', message: string) {
    super(message);
    this.name = 'ModelError';
  }
}
